export default __webpack_public_path__ + "static/media/repair.d310643f.svg";